import axios from "axios";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { Link, useNavigate } from "react-router-dom";
import imageCompression from "browser-image-compression";
import Swal from "sweetalert2";

export default function Comptambahpemain() {
  const urlapi = process.env.REACT_APP_BASE_URL;
  const upload_preset = process.env.REACT_APP_UPLOAD_PRESET_RANKTEAM;
  const cloud_name = process.env.REACT_APP_CLOUD_NAME_RANKTEAM;

  const [nama, setNama] = useState("");
  const [nickname, setNickname] = useState("");
  const [posisi, setPosisi] = useState("");
  const [nopunggung, setNopunggung] = useState("");
  const [jmlpemain, setJmlpemain] = useState(0);
  const [kuotapemain, setKuotapemain] = useState(0);
  const [nik, setNik] = useState("");
  const [notifnik, setNotifnik] = useState(false);
  const [panjangnik, setPanjangnik] = useState("");
  const [statusteam, setStatusteam] = useState(0);
  const [filektp, setFilektp] = useState(null);
  const [previewktp, setPreviewktp] = useState(null);
  const [filefoto, setFilefoto] = useState(null);
  const [previewfoto, setPreviewfoto] = useState(null);
  const [loadingfoto, setLoadingfoto] = useState(false);
  const [loadingktp, setLoadingktp] = useState(false);

  const navigate = useNavigate();

  const notify = () =>
    // Swal.close();
    toast.success("Data berhasil ditambah !", {
      position: toast.POSITION.TOP_CENTER,
    });

  const notify2 = () =>
    toast.warning("Nik yang anda masukan sudah terdaftar !", {
      position: toast.POSITION.TOP_CENTER,
    });

  const notify3 = () =>
    toast.error("Mohon maaf kuota tambah pemain sudah penuh!", {
      position: toast.POSITION.TOP_CENTER,
    });

  const notify4 = () =>
    toast.error("Mohon maaf anda tidak dapat menambah pemain!", {
      position: toast.POSITION.TOP_CENTER,
    });


  const addPemain = async (ktp, foto) => {
    await axios
      .post(urlapi + "Pemainrankteam", {
        id_user: localStorage.getItem("id"),
        nama_pemain: nama,
        posisi: posisi,
        no_punggung: nopunggung,
        nik: nik,
        nickname: nickname,
        foto: foto,
        ktp: ktp
      })
      .then((response) => {
        if (response.data.kuota == "full") {
          Swal.close();
          notify3();

        } else {
          Swal.close();
          notify();
        }

        jmlPememainrankteam();
        cekJmlpemain();
        setNama("");
        setPosisi("");
        setNopunggung("");
        setNik("");
        setNickname("");
        setPreviewfoto(null);
        setPreviewktp(null)
        setLoadingfoto(false);
        setLoadingktp(false);
      })
      .catch((error) => {
        console.log(error.message);
      });
  };

  const cekJmlpemain = async () => {
    try {
      const response = await axios.get(
        urlapi +
        "Pemainrankteam?jmlpemain=true" +
        "&&id_user=" +
        localStorage.getItem("id")
      );
      setJmlpemain(response.data);
      // console.log(response.data);
    } catch (error) { }
  };

  const jmlPememainrankteam = async () => {
    try {
      const response = await axios.get(urlapi + "Jmlpemainrankteam");
      // console.log(response.data);
      setKuotapemain(response.data.jml);
    } catch (error) { }
  };

  const handlenik = (e) => {
    setNik(e);
    ceknik(e);

    if (e.length == 16) {
      setPanjangnik("true");
    } else if (e.length > 16) {
      setPanjangnik("false1");
    } else if (e.length < 16) {
      setPanjangnik("false2");
    }
    // console.log(e);
  };

  const ceknik = async (nik) => {
    try {
      const response = await axios.get(urlapi + "Ceknik?nik=" + nik);
      // console.log(response.data);
      if (response.data == "") {
        setNotifnik(false);
      } else {
        setNotifnik(true);
      }
    } catch (error) {
      setNotifnik(false);
    }
  };

  const cekstatusteam = async () => {
    try {
      const response = await axios.get(urlapi + "Cekstatusteam?id=" + localStorage.getItem('id'));
      setStatusteam(response.data.status)
      // console.log(response.data);
    } catch (error) {

    }
  }

  const handleaddpemain = async () => {
    if (!filektp || !filefoto) {
      alert("Silakan pilih kedua gambar terlebih dahulu!");
      return;
    }

    Swal.fire({
      title: "Mengupload...",
      text: "Data anda sedang di proses.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading(); // animasi loading SweetAlert
      },
    });

    const uploadImage = async (file) => {
      const data = new FormData();
      data.append("file", file);
      data.append("upload_preset", upload_preset);
      data.append("cloud_name", cloud_name);

      const res = await fetch(`https://api.cloudinary.com/v1_1/${cloud_name}/image/upload`, {
        method: "POST",
        body: data,
      });
      return await res.json();
    };

    try {
      // Upload keduanya paralel agar lebih cepat
      const [uploadKtp, uploadPemain] = await Promise.all([
        uploadImage(filektp),
        uploadImage(filefoto),
      ]);

      console.log("KTP:", uploadKtp.secure_url);
      console.log("Foto Pemain:", uploadPemain.secure_url);

      // contoh simpan hasilnya
      const dataToSend = {
        ktp: uploadKtp.secure_url,
        foto_pemain: uploadPemain.secure_url,
      };

      console.log("Data siap dikirim ke backend:", dataToSend);
      addPemain(uploadKtp.secure_url, uploadPemain.secure_url)
    } catch (error) {
      console.error("Upload gagal:", error);
    }


  }

  const handleFileChangeKTP = async (e) => {
    const uploadedFile = e.target.files[0];
    const options = {
      maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
      maxWidthOrHeight: 800, // Dimensi maksimum
      useWebWorker: true,
    };
    setFilektp(uploadedFile);
    try {
      const compressedFile = await imageCompression(uploadedFile, options);
      console.log(compressedFile);

      // 🔄 Convert hasil kompres ke WebP
      const webpBlob = await convertToWebP(compressedFile);
      const webpFile = new File([webpBlob], "compressed.webp", { type: "image/webp" });
      setFilektp(webpFile)

      if (compressedFile != null) {
        setLoadingktp(true)
        const reader = new FileReader();
        reader.onloadend = () => {
          setPreviewktp(reader.result);
        };
        reader.readAsDataURL(webpFile);
      }

    } catch (error) {
      console.error("Gagal mengompres gambar:", error);
    }

  };

  const handleFileChangeFoto = async (e) => {
    const uploadedFile = e.target.files[0];
    const options = {
      maxSizeMB: 1, // Maksimum ukuran gambar dalam MB
      maxWidthOrHeight: 800, // Dimensi maksimum
      useWebWorker: true,
    };
    setFilefoto(uploadedFile);
    try {
      const compressedFile = await imageCompression(uploadedFile, options);
      console.log(compressedFile);

      // 🔄 Convert hasil kompres ke WebP
      const webpBlob = await convertToWebP(compressedFile);
      const webpFile = new File([webpBlob], "compressed.webp", { type: "image/webp" });
      setFilefoto(webpFile);
      if (compressedFile != null) {
        setLoadingfoto(true)
        if (uploadedFile) {
          const reader = new FileReader();
          reader.onloadend = () => {
            setPreviewfoto(reader.result);
          };
          reader.readAsDataURL(webpFile);
        }
      }

    } catch (error) {
      console.error("Gagal mengompres gambar:", error);
    }

  };

  const convertToWebP = (file) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      const reader = new FileReader();

      reader.onload = (e) => {
        img.src = e.target.result;
      };
      reader.readAsDataURL(file);

      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);
        canvas.toBlob(
          (blob) => blob ? resolve(blob) : reject("Gagal konversi ke WebP"),
          "image/webp",
          0.8 // kualitas (0.1 - 1)
        );
      };

      img.onerror = reject;
    });
  };

  useEffect(() => {
    jmlPememainrankteam();
    cekJmlpemain();
    cekstatusteam()
  }, []);

  return (
    <div>
      <div className="my-5">
        <div className="container">
          <br></br>
          <div className="card border-0" id="bggradient1">
            <div className="card-body text-white">
              <h5 className="fw-bold">
                <i className="fas fa-user-plus"></i> Tambah pemain team anda
              </h5>
              <small>
                Masukan data pemain team anda dengan benar sesuai data diri
              </small>
            </div>
          </div>
          <div>
            {/* <div className="alert alert-info mt-2 border-0 fw-bold">
              <small className="fw-bold">
                {" "}

                <i className="fas fa-circle-info"></i> Team yang sudah disetujui oleh admin
                tidak dapat mengubah nama pemain, nik
                pemain dan posisi pemain
              </small>
            </div> */}

            {statusteam == 0 ? <>
              <div className="alert alert-warning text-center mt-3">
                <h5><i className="fas fa-warning"></i></h5>
                <small className="fw-bold">Team anda belum dapat bermain rank team, silahkan menunggu persetujuan dari adamin</small>
              </div>
            </> : <div className="alert alert-success text-center mt-2">
              <h4><i className="fas fa-circle-check"></i></h4>
              <small className="fw-bold">Data team anda sudah disetujui, anda dapat melakukan bermain rank team sekarang</small>
            </div>}


          </div>
          <div className="card shadow mt-3" style={{ border: "none" }}>
            <div className="card-body">
              <small className="text-secondary">
                {" "}
                <i className="fas fa-user-plus"></i> Tambah pemain anda
              </small>
              <hr />

              <div className="row">
                <div className="col-sm-6 col-6">
                  <div className="form-group">
                    <label className="mb-1 fw-bold">Nama</label>
                    <input
                      className="form-control text-secondary"
                      onChange={(e) => setNama(e.target.value)}
                      name="nama"
                      value={nama}
                    />
                  </div>
                </div>
                <div className="col-sm-6 col-6">
                  <div className="form-group ">
                    <label className="mb-1 fw-bold">Posisi</label>
                    <select
                      className="form-control text-secondary"
                      name="posisi"
                      onChange={(e) => setPosisi(e.target.value)}
                    >
                      <option value="">-- Pilih posisi --</option>
                      <option>Penyerang</option>
                      <option>Gelandang serang</option>
                      <option>Gelandang sayap</option>
                      <option>Gelandang tengah</option>
                      <option>Bek sayap</option>
                      <option>Bek tangah</option>
                      <option>Penjaga gawang</option>
                    </select>
                  </div>
                </div>

                <div className="col-sm-12 col-12">
                  <div className="form-group mt-3">
                    <label className="mb-1 fw-bold">NIK</label>
                    <input
                      className="form-control text-secondary"
                      type="number"
                      name="nik"
                      onChange={(e) => handlenik(e.target.value)}
                      value={nik}
                    />
                    {notifnik == true ? (
                      <>
                        <small className="text-danger">
                          Nik yang anda masukan sudah terdaftar
                        </small>
                      </>
                    ) : (
                      ""
                    )}
                    <div></div>
                    {panjangnik == "true" ? (
                      <>
                        <small className="text-success">
                          Panjang nik sudah benar
                        </small>
                      </>
                    ) : panjangnik == "false1" ? (
                      <>
                        <small className="text-danger">Nik terlalu panjang</small>
                      </>
                    ) : panjangnik == "false2" ? (
                      <>
                        <small className="text-danger">Nik terlalu pendek</small>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <div className="col-sm-6 col-6 mt-3">
                  <label htmlFor="" className="fw-bold">Foto KTP</label>
                  <div className="text-center border rounded-3 p-4 bg-light position-relative">
                    <label
                      htmlFor="formFile"
                      className="form-label fw-semibold w-100 d-block"
                      style={{ cursor: "pointer" }}
                    >
                      {previewktp ? <>
                        <img
                          src={previewktp}
                          alt="Preview"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            maxHeight: "200px",
                            objectFit: "contain",
                            border: "2px solid #007bff",
                          }}

                        />
                        <div className="mt-1 text-secondary" style={{ fontSize: '11px' }}>Klik atau seret file untuk upload ktp</div>
                      </>

                        : (
                          <>
                            <i className="fas fa-file text-primary fs-3"></i>
                            <div className="text-primary" style={{ fontSize: '11px' }}>
                              {loadingktp == true ? 'Loading ...' : ''}
                            </div>
                            <div className="text-secondary" style={{ fontSize: '11px' }}>Klik atau seret file untuk upload ktp</div>
                          </>
                        )}
                    </label>

                    <input
                      className="form-control d-none"
                      type="file"
                      id="formFile"
                      accept=".jpg, .jpeg, .png"
                      onChange={handleFileChangeKTP}
                    />
                  </div>
                  {/* <small className="text-secondary" style={{ fontSize: '10px' }}>Format KTP pemain harus berformat gambar (jpg, jpeg, png)</small> */}
                </div>
                <div className="col-sm-6 col-6 mt-3">
                  <label htmlFor="" className="fw-bold">Foto Pemain</label>
                  <div className="text-center border rounded-3 p-4 bg-light position-relative">
                    <label
                      htmlFor="formFile2"
                      className="form-label fw-semibold w-100 d-block"
                      style={{ cursor: "pointer" }}
                    >
                      {previewfoto ? <>
                        <img
                          src={previewfoto}
                          alt="Preview"
                          className="img-fluid rounded shadow-sm"
                          style={{
                            maxHeight: "200px",
                            objectFit: "contain",
                            border: "2px solid #007bff",
                          }}

                        />
                        <div className="mt-1 text-secondary" style={{ fontSize: '11px' }}>Klik atau seret file untuk upload foto</div>
                      </>

                        : (
                          <>
                            <i className="fas fa-file text-primary fs-3"></i>
                            <div className="text-primary" style={{ fontSize: '11px' }}>
                              {loadingfoto == true ? 'Loading ...' : ''}
                            </div>
                            <div className="text-secondary" style={{ fontSize: '11px' }}>Klik atau seret file untuk upload foto</div>
                          </>
                        )}
                    </label>

                    <input
                      className="form-control d-none"
                      type="file"
                      id="formFile2"
                      accept=".jpg, .jpeg, .png"
                      onChange={handleFileChangeFoto}
                    />

                  </div>
                  {/* <small className="text-secondary" style={{ fontSize: '10px' }}>Format foto pemain harus berformat gambar (jpg, jpeg, png)</small> */}
                </div>

                {/* <div className="col-sm-6 col-6">
                  <div className="form-group mt-3">
                    <label className="mb-1 fw-bold">Foto Pemain</label>
                    <div className="mb-3 text-center border rounded-3 p-4 bg-light">
                      <label htmlFor="formFile" className="form-label fw-semibold">
                        <i className="fas fa-file text-primary fs-3"></i><br />
                        Klik atau seret file ke sini
                      </label>
                      <input
                        className="form-control d-none"
                        type="file"
                        id="formFile"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                </div> */}



              </div>






              <div className="d-flex justify-content-between">
                {nama == "" ||
                  posisi == "" ||
                  nik == "" ||
                  filefoto == null ||
                  filektp == null ||
                  notifnik == true ||
                  panjangnik == "false1" ||
                  panjangnik == "false2" ? (
                  <>
                    {" "}
                    <button
                      className="btn btn-primary mt-4 w-100 disabled rounded-pill"
                      style={{
                        marginRight: "10px",
                        backgroundColor: "#2b2e5a",
                      }}
                      onClick={() => addPemain()}
                    >
                      <i className="fas fa-plus"></i> Tambah
                    </button>
                  </>
                ) : (
                  <>
                    {" "}

                    {statusteam == 1 ? <>
                      <button
                        className="btn btn-primary mt-4 w-100 rounded-pill"
                        style={{
                          marginRight: "10px",
                          backgroundColor: "#2b2e5a",
                        }}
                        onClick={() => handleaddpemain()}
                      >
                        <i className="fas fa-plus"></i> Tambah
                      </button>
                    </> : <>

                      <button
                        className="btn btn-primary mt-4 w-100 rounded-pill"
                        style={{
                          marginRight: "10px",
                          backgroundColor: "#2b2e5a",
                        }}
                        onClick={() => handleaddpemain()}
                      >
                        <i className="fas fa-plus"></i> Tambah
                      </button>
                    </>}
                  </>
                )}

                <Link
                  onClick={() => navigate(-1)}
                  className="btn btn-primary mt-4 w-100 rounded-pill"
                  style={{ backgroundColor: "#2b2e5a" }}
                >
                  <i className="fas fa-angle-left"></i> Kembali
                </Link>
              </div>
            </div>
          </div>
          <ToastContainer />
        </div>
      </div>
    </div>
  );
}
